import { NO_ELEMENT } from 'utils';

export const SiteModeChangedModal = () => NO_ELEMENT;
